export default __webpack_public_path__ + "static/media/ic-paso-uno.23575e93.svg";